import axios from 'axios';
import SearchResult from './SearchResult';

export default class DirectoryApp {
    
    constructor(element) {
        this.element = element;
        this.form = this.element.querySelector('form');
        this.input = this.element.querySelector('input[type="text"]');
        this.searchTerm = "";
        this.results = [];
        this.apiBase = window.AppData.restBase;

        this.configureListeners();

        const alphaNav = document.querySelector('.alphabetical-nav');

        if (alphaNav) {
            this.alphaNav = new AlphabeticalNav(alphaNav);
        }
    }

    configureListeners() {
        this.form.addEventListener('submit', this.submitHandler.bind(this));
        this.input.addEventListener('keyup', this.keyUpHandler.bind(this));
    }

    submitHandler(event) {
        event.preventDefault();
        event.stopPropagation();

        this.search(this.searchTerm);
    }

    keyUpHandler() {
        this.searchTerm = this.input.value;

        if (this.searchTerm.length === 0) {
            this.clearResults();
        }

        if (this.searchTerm.length >= 3) {
            if (!this.loading) {
                this.search(this.searchTerm);
            }
        }
    }

    clearResults() {
        const existing = document.querySelector('.results-container');

        if (existing) {
            existing.remove();
        }
    }

    search(term) {
        this.loading = true;
        
        axios
            .get(`${this.apiBase}/search`, { params: { term } })
            .then(({ data }) => {
                this.displayResults(data);
            });
    }

    displayResults(data) {
        
        this.loading = false;
        
        this.clearResults();
        
        // Create a fresh results container
        const resultsContainer = document.createElement('div');
        resultsContainer.className = 'grid gap-4 mt-6 results-container md:grid-cols-2';
        this.element.appendChild(resultsContainer);

        if (data.length) {
            const resultObjects = data.map(r => new SearchResult(r));
            resultObjects.forEach(result => result.render(resultsContainer));
        }
    }
}